import cn from 'classnames';
import React, { ChangeEventHandler, forwardRef } from 'react';
import { Checkbox } from '@react-md/form';
import { Typography } from '@react-md/typography';
import { UserPurchaseTemplate } from '@services/df/inventory';
import { Fade } from '@components/animations';
import { Price } from '@components/price';
import { ModelCell } from '@modules/models';
import { PurchaseSpecification } from '@modules/product';
import { getNodeIdComposer } from '@utils';
import { RootPrefix } from './constants';

import styles from './inventory-page.module.scss';

const _id = getNodeIdComposer(RootPrefix, 'part');

interface InventoryPartProps {
    part: UserPurchaseTemplate;
    onChangeCheckbox: ChangeEventHandler<HTMLInputElement>;
    checked: boolean;
    delay: number;
    in?: boolean;
}

export const InventoryPart = forwardRef<HTMLTableRowElement, InventoryPartProps>(function InventoryPart(
    { part, onChangeCheckbox, checked, ...rest },
    ref,
) {
    const partId = part.id;

    return (
        <Fade as="tr" in className={styles.row} mountOnEnter unmountOnExit appear {...rest}>
            <td className={styles.cell}>
                <Checkbox
                    id={_id('checkbox', partId)}
                    onChange={onChangeCheckbox}
                    checked={checked}
                    value={partId}
                    disableIconOverlay
                    disableProgrammaticRipple
                    disableRipple
                />
            </td>
            <td className={styles.cell}>
                <ModelCell label={part.object_model_title} thumb={part.thumb_120x120} />
            </td>

            <td className={styles.cell}>
                <Typography type="body-2" component={'div'}>
                    {part.material_title}
                </Typography>
            </td>

            <td className={cn(styles.cell, styles.specification)}>
                {part.config ? <PurchaseSpecification fields={part.config_formatted_json} /> : '-'}
            </td>

            <td className={styles.cell}>
                <Typography type="body-2" component={'div'} className="rmd-typography--center">
                    {part.priority_days}
                </Typography>
            </td>

            <td className={styles.cell}>
                <Typography type="body-2" component={'div'} className="rmd-typography--center">
                    {part.quantity}
                </Typography>
            </td>

            <td className={cn(styles.cell, 'rmd-typography--right')}>
                <Typography type="body-2" component={'div'} className="rmd-typography--right">
                    <Price>{part.full_price}</Price>
                </Typography>
            </td>
        </Fade>
    );
});
